<template>
  <div class="cyber-science-table">
    <el-table
      v-if="showTable"
      ref="cyberTable"
      v-loading="tableLoading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      :data="loadedList"
      :header-cell-style="{background:'#eceff6',color:'#444444',border:'1px solid #dcdfe6'}"
      :cell-style="{border:'1px solid #dcdfe6'}"
      stripe
      :fit="true"
      :max-height="screenHeight - 50 > 600 ? screenHeight - 50 : 600"
      style="width:100%;border: 1px solid #dcdfe6;"
      row-key="id"
      :border="!isPc"
      :row-class-name="tableRowClassName"
      :tree-props="{ children: 'childrenList' }"
    >
      <el-table-column label="序号" :width="isPc?'60':'46'" align="center" fixed="left">
        <template slot-scope="scope">
          <span>{{ scope.row.id | filterId(1) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="sourceName"
        :label="showOperation?'来源渠道\n(手机号)':'来源渠道\n(ID)'"
        :width="isPc?'':'70'"
        align="center"
        :fixed="!isPc"
      >
        <template slot-scope="scope">
          <div>
            {{ showOperation?scope.row.name:scope.row.sourceName+'('+scope.row.sourceId+')' }}
          </div>
        </template>
      </el-table-column>
      <!-- 网络安全科普大赛总分 -->
      <el-table-column align="center" :label="'网络安全\n科普大赛总分\n(7.22-7.31)'" :min-width="isPc?'96':'78'">
        <template slot-scope="scope">
          <div>{{ getValue(scope.row, 'totalPoint') }}</div>
        </template>
      </el-table-column>
      <!-- 动态阶段列：第一阶段 ~ 冲刺阶段 -->
      <el-table-column
        v-for="phase in phases"
        :key="phase.key"
        align="center"
      >
        <!-- 表头：阶段名称 + 查看/收起明细按钮 -->
        <template slot="header">
          <div class="phase-header">
            <span>{{ phase.label }}</span>
            <span class="phase-date">{{ phase.date }}</span>
            <el-button
              size="mini"
              class="toggle-btn"
              @click="togglePhase(phase.key)"
            >
              {{ expandedPhases.includes(phase.key) ? '收起' : '查看明细' }}
            </el-button>
          </div>
        </template>
        <!-- 折叠态：仅显示阶段总分 -->
        <el-table-column
          v-if="!expandedPhases.includes(phase.key)"
          :label="phase.label+'\n(X+25%Y)'"
          align="center"
          :min-width="isPc?'98':'78'"
        >
          <template slot-scope="scope">
            <span>{{ getStageField(scope.row, phase, 'TotalPoint') }}</span>
          </template>
        </el-table-column>
        <!-- 展开态：多级表头 -->
        <template v-else>
          <el-table-column :label="phase.label+'\n(X+25%Y)'" align="center" :min-width="isPc?'98':'78'">
            <template slot-scope="scope">
              <span>{{ getStageField(scope.row, phase, 'TotalPoint') }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="`${phase.shortName}主问卷采集量(X)`" align="center">
            <el-table-column :label="`小计(X)`" align="center" :min-width="isPc?'':'60'">
              <template slot-scope="scope">
                <span>{{ getStageField(scope.row, phase, 'Amount') }}</span>
              </template>
            </el-table-column>
            <el-table-column label="公众版" align="center" :min-width="isPc?'':'55'">
              <template slot-scope="scope">
                <span>{{ getStageField(scope.row, phase, 'PublicAmount') }}</span>
              </template>
            </el-table-column>
            <el-table-column label="从业版" align="center" :min-width="isPc?'':'55'">
              <template slot-scope="scope">
                <span>{{ getStageField(scope.row, phase, 'EmploymentAmount') }}</span>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column :label="`${phase.shortName}\n专题问卷采集量\n(Y)`" align="center" :min-width="isPc?'112':'86'">
            <template slot-scope="scope">
              <span>{{ getStageField(scope.row, phase, 'SpecialAmount') }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column :label="`${phase.shortName}\n竞赛得分\n(Z)`" align="center" :min-width="isPc?'90':'70'">
            <template slot-scope="scope">
              <span>{{ getStageField(scope.row, phase, 'ExtraPoint') }}</span>
            </template>
          </el-table-column> -->
        </template>
      </el-table-column>
      <el-table-column label="竞赛得分" align="center" :min-width="isPc?'80':'70'">
        <template slot-scope="scope">
          <span>{{ scope.row.matchPoint }}</span>
        </template>
      </el-table-column>
      <!-- 操作列 -->
      <el-table-column v-if="showOperation" label="操作" :width="isPc?'120':'60'" align="center">
        <template slot-scope="scope">
          <div style="margin-top: 5px;">
            <el-button
              v-if="!!scope.row.sourceId"
              @click="handleCheckInvitation(scope.row.sourceId)"
              type="primary"
              size="mini"
            >已邀数量</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
/**
 * 网安科普大赛表格组件
 * 支持分批加载 + 多级表头展开/收起
 *
 * 后端字段映射 (camelCase)：
 *   总分            → totalPoint
 *   竞赛得分        → matchPoint
 *   各阶段总分       → {backendStageKey}TotalPoint   (X+25%Y)
 *   主问卷采集量小计  → {backendStageKey}Amount
 *   公众版           → {backendStageKey}PublicAmount
 *   从业版           → {backendStageKey}EmploymentAmount
 *   专题问卷采集量    → {backendStageKey}SpecialAmount
 *   竞赛得分(Z)      → {backendStageKey}ExtraPoint
 *   基础分           → {backendStageKey}BasicPoint
 */
export default {
  name: 'CyberScienceTable',
  props: {
    showTable: { type: Boolean, default: false },
    tableLoading: { type: Boolean, default: false },
    isPc: { type: Boolean, default: true },
    screenHeight: { type: Number, default: document.body.clientHeight },
    // 全量数据（接口返回后全部传入）
    rawData: { type: Array, default: () => [] },
    chunkSize: { type: Number, default: 50 },
    // 是否显示操作列（已邀数量按钮），弹窗内嵌表格传 false
    showOperation: { type: Boolean, default: true },
  },
  data() {
    return {
      collectBaseList: [],     // 全量数据（内部维护）
      loadedList: [],          // 已分批加载的数据
      busy: false,
      expandedPhases: [],      // 当前展开明细的阶段 key 列表
      _scrollEl: null,
      // 阶段定义：key 用于前端 toggle，backendStageKey 对应后端字段前缀
      phases: [
        { key: 'phase1', backendStageKey: 'firstStage',  label: '第一阶段得分', date: '(7.22-7.24)', shortName: '第一阶段' },
        { key: 'phase2', backendStageKey: 'secondStage', label: '第二阶段得分', date: '(7.25-7.27)', shortName: '第二阶段' },
        { key: 'phase3', backendStageKey: 'thirdStage',  label: '第三阶段得分', date: '(7.28-7.30)', shortName: '第三阶段' },
        { key: 'sprint', backendStageKey: 'fourStage',   label: '冲刺阶段得分', date: '(7.31)',      shortName: '冲刺阶段' },
      ],
    }
  },
  watch: {
    rawData: {
      immediate: true,
      handler(val) {
        if (val && val.length > 0) {
          this.collectBaseList = val
          this.resetAndLoad()
        }
      }
    }
  },
  filters: {
    filterId: function (value, type) {
      if(!value) {
        return ' '
      }
      let count = 0;
      for (let i = 0; i < value.length; i++) {
        if (value.charAt(i) === '-') {
          count++;
        }
      }
      if(count===0) {
        return Number(value)?value:' '
      }else if ( type === 2 && count===1 ) {
        let ary = value.split('-')
        return `(${ary[count]})`
      }else if ( type === 2 && count===2 ) {
        let ary = value.split('-')
        return `[${ary[count]}]`
      }else {
        return ' '
      }
    },
  },
  mounted() {
    this.$nextTick(() => this.bindTableScroll())
  },
  beforeUnmount() {
    this.unbindTableScroll()
  },
  methods: {
    // ---------- 通用取值（空值/undefined 返回 '-'） ----------
    getValue(row, field) {
      return (row[field] !== undefined && row[field] !== null && row[field] !== '') ? row[field] : '-'
    },
    // ---------- 各阶段字段取值 ----------
    getStageField(row, phase, field) {
      return this.getValue(row, `${phase.backendStageKey}${field}`)
    },
    // ---------- 展开/收起 ----------
    togglePhase(key) {
      const idx = this.expandedPhases.indexOf(key)
      if (idx > -1) {
        this.expandedPhases.splice(idx, 1)
      } else {
        this.expandedPhases.push(key)
      }
      // 表头结构变化后重新布局
      this.$nextTick(() => {
        if (this.$refs.cyberTable) {
          this.$refs.cyberTable.doLayout()
        }
      })
    },
    // ---------- 分批加载 ----------
    async resetAndLoad() {
      this.unbindTableScroll()
      this.loadedList = []
      this.busy = false
      await this.$nextTick()
      this.loadMore()
      this.$nextTick(() => this.bindTableScroll())
    },
    async loadMore() {
      if (this.busy || this.loadedList.length >= this.collectBaseList.length) return
      this.busy = true
      await this.$nextTick()
      const nextChunk = this.collectBaseList.slice(
        this.loadedList.length,
        this.loadedList.length + this.chunkSize
      )
      this.loadedList.push(...nextChunk)
      this.busy = false
    },
    bindTableScroll() {
      this.unbindTableScroll()
      const el = this.$refs.cyberTable && this.$refs.cyberTable.$el.querySelector('.el-table__body-wrapper')
      if (el) {
        el.scrollTop = 0
        el.addEventListener('scroll', this.handleTableScroll, { passive: true })
        this._scrollEl = el
      }
    },
    unbindTableScroll() {
      if (this._scrollEl) {
        this._scrollEl.removeEventListener('scroll', this.handleTableScroll)
        this._scrollEl = null
      }
    },
    handleTableScroll(e) {
      const t = e.target
      if (t.scrollHeight > t.clientHeight && t.scrollTop + t.clientHeight >= t.scrollHeight - 50) {
        this.loadMore()
      }
    },
    // ---------- 样式与操作 ----------
    tableRowClassName({ rowIndex }) {
      return rowIndex === 0 ? 'success-row' : ''
    },
    handleCheckInvitation(sourceId) {
      this.$emit('checkInvitation', sourceId)
    },
  }
}
</script>

<style scoped>
.cyber-science-table {
  width: 100%;
}
.phase-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 1.4;
}
.phase-date {
  font-size: 11px;
  color: #888;
}
.toggle-btn {
  border: none;
  padding: 4px 8px !important;
  background-color: #F69931;
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
  margin-top: 2px;
}
.toggle-btn i {
  margin-left: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/table/CyberScienceTable.vue